<template>
  <section class="page-container">
    <div>
      <h1>Campaigns</h1>
      <div
        class="btn-top-container">
        <v-button
          v-if="activeTab=='travel'"
          gray
          @click="handlerToExportList"
        >Export List
        </v-button>
        <v-button
          v-if="activeTab == 'purchases'"
          gray
          @click="hanldeImport"
        >Import
        </v-button>
        <v-button
          v-if="showExportBtn"
          gray
          :disabled="exportDisable&&!isPopTravel"
          @click="handlerDown"
        >Export Excel
        </v-button>
      </div>
    </div>
    <el-tabs
      v-model="activeTab"
      @tab-click="changeTab">
      <el-tab-pane
        v-for="(tab, index) in newTabList"
        :key="index"
        :name="tab.name"
      >
        <span slot="label">
          <span class="flex">
            <span>{{tab.label}}</span>
            <el-badge
              v-if="tab.name=='pv-renew-promo'"
              :value="pendingNum"
              :max="99"
              class="aside-dot"
              :class="{'is-update':true}">
            </el-badge>
            <el-badge
              v-if="tab.name=='road-bomb'"
              :value="road_bomb_num"
              :max="99"
              class="aside-dot"
              :class="{'is-update':true}">
            </el-badge>
          </span>
        </span>
      </el-tab-pane>
    </el-tabs>
    <router-view
      ref="child"
      @changeDate='setExportStatus'></router-view>
  </section>
</template>

<script>
import {getListCount, logout} from '@api'

export default {
  name: 'campaignsList',
  components:{
  },
  data() {
    return{
      countList:{},
      exportDisable: true,
      activeTab: 'purchases',
      tabList:['PV Renew Promo','$200 Flight Delay','Purchases','HD Redeem','KFLM', 'Gift Pack','Travel','Free-Round-Trip','Welcome Offer', 'HANBERG Card','HZMB','Road Bomb','HANBERG Cashback']
    }
  },
  computed:{
    newTabList(){
      return[
        {
          label: 'PV Renew Promo',
          name: 'pv-renew-promo'
        },
        {
          label: '$200 Flight Delay',
          name: 'flight-delay'
        },
        {
          label: 'Purchases',
          name: 'purchases'
        },
        {
          label: 'HD Redeem',
          name: 'HD-redeem'
        },
        {
          label: 'Gift Pack',
          name: 'gift-pack'
        },
        {
          label: 'Travel',
          name: 'travel'
        },
        {
          label: 'Free-Round-Trip',
          name: 'free-round-trip'
        },
        {
          label: '01 Space',
          name: '01-space'
        },
        {
          label: 'Welcome Offer',
          name: 'welcome-offer'
        },
        {
          label: 'Aqua Land',
          name: 'aqua-land'
        },
        {
          label: 'HANBERG Card',
          name: 'HANBERG-card'
        },
        {
          label: 'HZMB',
          name: 'HZMB'
        },
        {
          label: 'Road Bomb',
          name: 'road-bomb'
        },
        {
          label: 'Fire&Home',
          name: 'home-fire'
        },
        {
          label: 'HANBERG Cashback',
          name: 'HANBERG-cashback'
        },
        {
          label: 'Traveller 2024',
          name: 'traveller-2024'
        },
        {
          label: '旅遊達人',
          name: 'tourist-list'
        },
        {
          label: 'No Claim Reward',
          name: 'no-claim'
        },
      ]
    },
    showExportBtn(){
      let {name} = this.$route
      return !['welcome-offer','free-round-trip','home-fire','no-claim','aqua-land'].includes(name)
    },
    isPopTravel(){
      let {name} = this.$route
      return name =='tourist-list'
    },
    pendingNum(){
      let {pv_renew_pending_num} = this.countList||{}
      return pv_renew_pending_num||0
    },
    road_bomb_num(){
      let {road_bomb_pending_num} = this.countList||{}
      return road_bomb_pending_num||0
    }
  },
  watch:{
    '$route':{
      immediate: true,
      deep: true,
      handler(val){
        this.activeTab = val.name
      }
    },
  },
  mounted() {
    this.network().getListCount()
  },
  methods: {
    handlerToExportList(){
      this.$router.push('/admin-cms/marketing-report?name=list')
    },
    handlerDown() {
      this.$refs['child'].handlerDown()
    },
    hanldeImport(){
      this.$router.push({
        path: '/records/micropolicy/import-tracking-number'
      })
    },

    setExportStatus(val){
      this.exportDisable = val.length == 0
    },

    changeTab(){
      this.exportDisable = true
      this.$router.push({
        name:this.activeTab,
      })
    },
    network() {
      return {
        getListCount: async () => {
          let {data} = await getListCount()
          this.countList = data
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container{
  position: relative;
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
  .aside-dot{
    //height: 20px;
    //width: 20px;
    //font-size: 12px;
    //letter-spacing: 0;
    //line-height: 16px;
    //text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left:8px;
    ::v-deep .el-badge__content{
      color: #24292E;
      border:1px solid #E1E4E8;
      background: #FFFFFF;
    }
    &.is-update{
      ::v-deep .el-badge__content{
        color: #fff;
        border:0;
        background-color: #0366D6;
      }
    }
    &.is-info{
      ::v-deep .el-badge__content{
        color: #24292E;
        border:0;
        background: rgba(209, 213, 218, 0.5);
      }
    }
  }
}
</style>
